<div
  class="container vw-100 vh-100 d-flex direction-column"
  [ngClass]="{ 'ptb-15': action === 'edit', 'plr-40': action === 'edit' }"
>
  <ng-container *ngIf="contracts.length === 0 && action === 'edit'">
    <div class="conteudo-contracts contracts d-flex direction-column row-gap-8">
      <div class="contracts-empty empty">
        <span class="empty-message"> Sem contratos disponíveis </span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="action === 'edit'">
    <ng-container *ngFor="let contract of contracts; let i = index">
      <div class="d-flex">
        <app-cards-contratos-lotes
          [contract]="contract"
          [showBeneficiaryName]="true"
          [typeDetail]="typeLot"
          [isModal]="true"
          class="vw-100"
        >
          <ng-container checkbox>
            <app-c-checkbox
              [contractNumberInput]="false"
              [checked]="checkContract(contract)"
              [id]="contract.Number"
              (change)="checkUncheckContract(contract)"
            ></app-c-checkbox>
          </ng-container>
        </app-cards-contratos-lotes>
      </div>
    </ng-container>
  </ng-container>
</div>
